import styles from 'styles/components/checkout/caap/desktopOnly.scss';

const DesktopOnly = ({ children }) => (
  <div className={styles.hideSmallScreen}>{children}</div>
);

export default DesktopOnly;
